import { Routes } from '@angular/router';

import { DashboardComponent } from './dashboard/dashboard.component';

export const homeRoutes: Routes = [
  {
    path: 'home',
    data: {
      mainTool: 'home',
      title: 'Home',
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          tool: 'dashboard',
          title: 'Dashboard',
        },
      },
    ],
  },
];
